<template>
  <div>
    <v-btn :to="'/events/' + $route.params.id" class="ma-0 mb-5">
      Назад
    </v-btn>
    <h1 class="mb-4">Каталог услуг</h1>

    <v-card class="mb-5">
      <v-card-title>
        <v-spacer />
        <v-btn color="primary" @click="openCreate">
          <v-icon left>mdi-plus</v-icon>Добавить услугу
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="services"
        :loading="loading"
        no-data-text="Услуги не найдены"
      >
        <template v-slot:item.price="{ item }">
          {{ item.price.toLocaleString('ru-RU') }} ₽
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-chip :color="item.is_active ? 'success' : 'error'" small>
            {{ item.is_active ? 'Активна' : 'Скрыта' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click="openEdit(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon small color="error" @click="confirmDelete(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Диалог создания/редактирования -->
    <v-dialog v-model="dialog" max-width="560">
      <v-card>
        <v-card-title>{{ editMode ? 'Редактировать услугу' : 'Новая услуга' }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Название" outlined dense :rules="[v => !!v || 'Обязательное поле']" />
          <v-text-field v-model="form.category" label="Категория" outlined dense />
          <v-text-field
            v-model.number="form.price"
            label="Цена, ₽"
            type="number"
            outlined
            dense
            min="0"
          />
          <v-textarea v-model="form.description" label="Описание" outlined dense rows="2" />
          <v-switch v-model="form.is_active" label="Активна" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Отмена</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог подтверждения удаления -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title>Скрыть услугу?</v-card-title>
        <v-card-text>
          «{{ deleteTarget && deleteTarget.name }}» будет скрыта из каталога (не удалена).
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="deleteDialog = false">Отмена</v-btn>
          <v-btn color="error" :loading="deleting" @click="doDelete">Скрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'

export default {
  name: 'EventServicesCatalog',
  data() {
    return {
      services: [],
      loading: false,
      saving: false,
      deleting: false,
      dialog: false,
      deleteDialog: false,
      editMode: false,
      deleteTarget: null,
      form: {
        id: null,
        name: '',
        category: '',
        price: 0,
        description: '',
        is_active: true,
      },
      headers: [
        { text: 'Название', value: 'name' },
        { text: 'Категория', value: 'category' },
        { text: 'Цена', value: 'price' },
        { text: 'Статус', value: 'is_active' },
        { text: 'Действия', value: 'actions', sortable: false },
      ],
    }
  },
  async mounted() {
    await this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        this.services = await Api.getEventServices({
          event_id: this.$route.params.id,
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.editMode = false
      this.form = { id: null, name: '', category: '', price: 0, description: '', is_active: true }
      this.dialog = true
    },
    openEdit(item) {
      this.editMode = true
      this.form = { ...item }
      this.dialog = true
    },
    async save() {
      if (!this.form.name) return
      this.saving = true
      try {
        if (this.editMode) {
          await Api.updateEventService({ ...this.form })
        } else {
          await Api.createEventService({
            ...this.form,
            event_id: this.$route.params.id,
          })
        }
        this.dialog = false
        await this.load()
      } catch (e) {
        console.error(e)
      } finally {
        this.saving = false
      }
    },
    confirmDelete(item) {
      this.deleteTarget = item
      this.deleteDialog = true
    },
    async doDelete() {
      this.deleting = true
      try {
        await Api.deleteEventService({ id: this.deleteTarget.id })
        this.deleteDialog = false
        await this.load()
      } catch (e) {
        console.error(e)
      } finally {
        this.deleting = false
      }
    },
  },
}
</script>
